<template>
  <div>
    <ol class="breadcrumb float-xl-right">
      <li class="breadcrumb-item">
        <router-link :to="{name:'dashboard'}">Dashboard</router-link>
      </li>
      <li class="breadcrumb-item"><a href="#">Payments</a></li>
    </ol>
    <h1 class="page-header">Payments</h1>
    <panel noButton="true" title="Payments" variant="panel-default">
      <vue-good-table mode="remote" :lineNumbers="true"
                      :rows="rows"
                      :columns="columns"
                      :totalRows="totalRecords"
                      :search-options="{ enabled: true, trigger: 'enter' }"
                      :pagination-options="{ enabled: true}"
                      :isLoading.sync="isLoading"
                      @on-per-page-change="onPerPageChange"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-search="onSearch"
      >
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field == 'action'">
            <div>
              <router-link v-if="getPayable(props.row.payable_type) === 'Bidbond'"
                           :to="{ name: 'bidbonds.show', params: { id: props.row.payable_id }}">
                {{ getPayable(props.row.payable_type) }}
              </router-link>
              <router-link v-if="getPayable(props.row.payable_type) === 'Company'"
                           :to="{ name: 'companies.show', params: { id: props.row.payable_id }}">
                {{ getPayable(props.row.payable_type) }}
              </router-link>
              <router-link v-if="getPayable(props.row.payable_type) === 'Agent'"
                           :to="{ name: 'agents.show', params: { secret: props.row.payable_id }}">
                {{ getPayable(props.row.payable_type) }}
              </router-link>
              <router-link
                  v-if="!props.row.confirmed && $can.view($store.getters.getAuthUser, 'confirm-payment')"
                  class="btn btn-sm btn-primary"
                  :to="{name: 'payments.verify',params:{account: props.row.transaction_number}}">
                Confirm
              </router-link>
            </div>
          </div>
          <span v-else-if="props.column.field == 'confirmed'">
            <i class="fa" :class="[props.row.confirmed ? 'fa-check text-success' : 'text-warning fa-times']"></i>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
        <div slot="table-actions">
          <download-excel :data="rows" :title="'Payment Report'" class="btn btn-primary" name="AllPayments.xls">
            <i class="fa fa-file-excel"></i> Export Excel
          </download-excel>
          <router-link class="btn btn-info ml-2" v-if="$can.view($store.getters.getAuthUser, 'create-payment')"
                       :to="{name:'payments.create'}">Create
          </router-link>
        </div>
      </vue-good-table>
    </panel>
  </div>
</template>

<script>
import tables, {tableData} from "@/mixins/tables";

export default {
  mixins: [tables],
  data() {
    return {
      payments: [],
      ...tableData,
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Phone ",
          field: "phone",
          sortable: false,
        },
        {
          label: "Account",
          field: "account",
          sortable: false,
        },
        {
          label: "Amount",
          field: "amount",
          type: 'number',
        },
        {
          label: "Transaction Number",
          field: "transaction_number",
          sortable: false,
        },
        {
          label: "Payment Channel",
          field: "payment_method",
        },
        {
          label: "Transaction Date",
          field: "transaction_date",
        },
        {
          label: 'Status',
          field: 'confirmed',
          sortable: false,
        },
        {
          label: 'Type',
          field: 'action',
          sortable: false,
        },
      ],
    }
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    loadItems() {
      this.$axios.get('/api/v1/payments', {
        params: this.serverParams
      }).then(response => {
        this.totalRecords = response.data.total;
        this.rows = response.data.data;
      });
    },
    formatStateIcon(value) {
      return value ? "<i class='fa fa-check'></i>" : "<i class='fa fa-times'></i>"
    },
    getPayable(payable_type) {
      return payable_type.replace("App\\", "");
    },
  }
}
</script>